import { render, staticRenderFns } from "./ThePanel.vue?vue&type=template&id=5174cbd6"
import script from "./ThePanel.vue?vue&type=script&lang=js"
export * from "./ThePanel.vue?vue&type=script&lang=js"
import style0 from "./ThePanel.vue?vue&type=style&index=0&id=5174cbd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports